import { EyeArrowLeftOutlineIcon } from './EyeArrowLeftOutlineIcon';

/**
 * author: Michael Irigoyen
 * id D979FDDF-45AE-4F37-AC6C-A92B2860BC02
 * name eye-arrow-left-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-arrow-left-outline.svg
 * tags
 */
export const ViewArrowLeftOutlineIcon = EyeArrowLeftOutlineIcon;
export default ViewArrowLeftOutlineIcon